import { identityActions } from '../../services';

export const settingsReducer = ( state = { withConfig: true }, action ) => {
  switch ( action.type ) {
    case identityActions.LOAD:
      return { ...state, auth: action.data };
    default:
      return state;
  }
};